import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import ReactGA from 'react-ga';
import MakeCard from "./Components/MakeCard";
import QRcodegenerate from "./Components/QRcodegenerate";

function App() {

  const TRACKING_ID = process.env.REACT_APP_TRACKING_ID;
  ReactGA.initialize(TRACKING_ID);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<QRcodegenerate/>}/>
        <Route path="bcard" element={<MakeCard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
